module.exports = __webpack_public_path__ + "static/media/click.a05e7cda.gif";